import React, { useState, useEffect } from 'react';
import { Logo } from '../../components';
import auth1 from '../../assets/images/auth1.jpg';
import auth2 from '../../assets/images/auth2.jpg';
import auth3 from '../../assets/images/auth3.jpg';
import auth4 from '../../assets/images/auth4.jpg';
import auth5 from '../../assets/images/auth5.jpg';
import auth6 from '../../assets/images/auth6.jpg';
import logo from '../../assets/images/full_logo.png';

const imageUrls = [auth1, auth2, auth3, auth4, auth5, auth6];

export default function RegisterPage() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setFade(false);

      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % imageUrls.length);
      setTimeout(() => {
        setFade(true);
      }, 300); // Adjust this value to match your fade-out duration
    }, 5000); // Change image every 3 seconds

    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="flex min-h-screen">
      <div className="relative hidden w-0 flex-1 lg:block">
        <img
          className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-300 ${
            fade ? 'opacity-100' : 'opacity-0'
          }`}
          src={imageUrls[currentImageIndex]}
          alt="login"
        />
      </div>
      <div className="flex flex-1 flex-col justify-center px-4 py-12 sm:px-6 lg:flex-none lg:px-20 xl:px-24 relative">
        <div className="flex justify-center p-2 absolute top-2 left-2">
          {/* <Logo size="sm" /> */}
          <img src={logo} alt="Property Cast Logo" className="h-20"></img>
        </div>
        <div className="mx-auto w-full max-w-sm lg:w-96 fade-in-down delay-400">
          <div className="mt-4">
            <h2 class="mb-6 mt-4 text-center text-2xl font-medium leading-9 tracking-tight text-gray-700">
              Create your account
            </h2>
            <div
              data-o-auth="1"
              data-mode="embed"
              data-widget-mode="register"
              data-plan-uid="vWyzRymb"
              data-authentication-callback-url={
                window.location.origin + '/dashboard'
              }
              data-skip-plan-options={true}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
}
